import { render, staticRenderFns } from "./modules3.vue?vue&type=template&id=da3bbaa0&scoped=true"
import script from "./modules3.vue?vue&type=script&lang=js"
export * from "./modules3.vue?vue&type=script&lang=js"
import style0 from "./modules3.vue?vue&type=style&index=0&id=da3bbaa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3bbaa0",
  null
  
)

export default component.exports